import React, { ReactNode } from 'react';
import classnames from 'classnames';

import styles from './styles.module.scss';

interface IWidgetWrapper {
  externalClasses?: string;
  testId?: string;
  children: Nullable<ReactNode>;
  ariaLabel?: string;
}

const WidgetWrapper = (props: IWidgetWrapper) => (
  <div
    className={classnames(styles.wrapper, props.externalClasses)}
    data-testid={props.testId}
    aria-label={props.ariaLabel}
  >
    {props.children}
  </div>
);

export default WidgetWrapper;
